var map = {
	"./btn_share_en.png": 3676,
	"./btn_share_es.png": 4035,
	"./btn_share_fr.png": 7516,
	"./btn_share_hi.png": 3414,
	"./btn_share_jp.png": 8064,
	"./btn_share_kr.png": 5290,
	"./btn_share_mn.png": 7626,
	"./btn_share_pl.png": 7168,
	"./btn_share_pt.png": 5076,
	"./btn_share_ru.png": 7612,
	"./btn_share_th.png": 8651,
	"./btn_share_vi.png": 6602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7850;